import { makeGraphQLRequest } from '../../../utils/requestUtils';

export default async function unblockUser(id) {
  const query = `mutation unblockUser( $id: ID) { unblockUser (id: $id) { id } }`;

  const variables = { id };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}



// WEBPACK FOOTER //
// ./src/components/grids/ViewUsersGrid/graphql.js